import React, { useState } from 'react'
import 'url-search-params-polyfill'

export const TokenContext = React.createContext([
  null,
  ((_token) => null)
])

export const TokenProvider = ({ children }) => {
  const [token, setToken] = useState(new URLSearchParams(window.location.search).get('token'))

  return <TokenContext.Provider value={[token, setToken]}>{children}</TokenContext.Provider>
}
